module.exports = __webpack_public_path__ + "img/close.ee331d11.svg";